<aecom-form columns="12" class="contentcontainer">
  @if (responseDetail) {
    <aecom-form-group columnSpan="12" columns="1" [title]="title" style="margin-bottom: 40px;">
      <responseDetail [item]="responseDetail" style="margin-top: 16px;"></responseDetail>
      @if (managerResponseDetail) {
        <managerResponseDetail [item]="managerResponseDetail" style="margin-top: 16px;"></managerResponseDetail>
      }
    </aecom-form-group>
  }
  <aecom-form-group columnSpan="12" columns="1" title="Timeline">
    <timeline [data]="timelineItems"></timeline>
  </aecom-form-group>
</aecom-form>